/**
 * Grid Tap-to-Swap (mobile only)
 */

(function () {
  'use strict';

  var MOBILE_MEDIA_QUERY = '(max-width: 768px)';

  var TAPPED_CLASS = 'is-tapped';
  
  var CARD_SELECTOR = '.grid-product__content';

  var EXCLUDE_SELECTOR =
    '.grid-product__color-image, [data-swatch], .swatch, .color-swatch, ' +
    'button, input, select, textarea, [data-no-tap-swap]';

  var MOVE_THRESHOLD = 10; // px of finger movement before we call it a scroll, not a tap
  var TIME_THRESHOLD = 500; // ms — a touch held longer than this isn't treated as a tap

  var activeCard = null;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchStartTime = 0;

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  function isMobileBreakpoint() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function clearActiveCard() {
    if (activeCard) {
      activeCard.classList.remove(TAPPED_CLASS);
      activeCard = null;
    }
  }

  function onTouchStart(event) {
    if (!isTouchDevice() || !isMobileBreakpoint()) return;
    var touch = event.touches[0];
    if (!touch) return;
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    touchStartTime = Date.now();
  }

  function onTouchEnd(event) {
    if (!isTouchDevice() || !isMobileBreakpoint()) return;

    var touch = event.changedTouches && event.changedTouches[0];
    if (!touch) return;

    var movedX = Math.abs(touch.clientX - touchStartX);
    var movedY = Math.abs(touch.clientY - touchStartY);
    var elapsed = Date.now() - touchStartTime;

    // A scroll/swipe, not a tap — leave everything as-is so scrolling
    // is never interrupted.
    if (movedX > MOVE_THRESHOLD || movedY > MOVE_THRESHOLD || elapsed > TIME_THRESHOLD) {
      return;
    }

    var target = event.target;
    var card = target.closest ? target.closest(CARD_SELECTOR) : null;

    if (!card) {
      // Tapped outside any card — reset whatever was showing.
      clearActiveCard();
      return;
    }

    // Swatches / quick add / form controls behave independently of the
    // image swap — don't intercept their tap at all.
    if (target.closest(EXCLUDE_SELECTOR)) {
      return;
    }

    if (card === activeCard) {
      // Second tap on the card that's already showing its secondary
      // image — do nothing and let the <a> navigate normally.
      return;
    }

    // First tap on a (different) card — swap its image, reset whatever
    // card was previously active, and stop this tap from also
    // triggering navigation.
    event.preventDefault();
    clearActiveCard();
    card.classList.add(TAPPED_CLASS);
    activeCard = card;
  }

  function onScroll() {
    if (activeCard) clearActiveCard();
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function init() {
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: false });
    window.addEventListener('scroll', debounce(onScroll, 150), { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.theme = window.theme || {};
  window.theme.GridTapToSwap = { reset: clearActiveCard };
})();